import axios from 'axios';
import { JobListFilters, JobSortOption, StatusValue } from './jobApi';
import { ActivityBucket } from 'components/Jobs/Filters/TimeSinceLastActiveAutocompleteForFilter';

interface AddOrUpdateCheckedColumnsResponse {
  success: boolean;
  message: string;
  data?: {
    jobCategory: string;
    selectedColumns: string[];
  };
}
interface AddOrUpdateFilteredItemsResponse {
  success: boolean;
  message: string;
  data?: JobListFilters;
}

export interface FilterData {
  clientLegalName: string[];
  state: string[];
  branchId?: string[];
  currentStatus: StatusValue[];
  selectedColumns: string[];
  myJobs: string;
  projectCoordinatorId: string[];
  projectSupervisorId?: string[];
  timeSinceLastActive?: ActivityBucket[];
  lastActivityFrom?: string | null;
  lastActivityTo?: string | null;
  sortBy?: JobSortOption | null;
}

export interface FiltersResponse {
  allJobsFilterData: FilterData;
  openJobsFilterData: FilterData;
  closedJobsFilterData: FilterData;
  myJobsFilterData: FilterData;
}

export async function addOrUpdateFilteredItems(
  filteredData: JobListFilters
): Promise<AddOrUpdateFilteredItemsResponse> {
  const { data } = await axios.post(`/api/v1/job-filter`, filteredData);
  return data.payload;
}

export async function addOrUpdateCheckedColumns(filteredData: {
  jobCategory: string;
  selectedColumns: string[];
}): Promise<AddOrUpdateCheckedColumnsResponse> {
  const { data } = await axios.post(
    `/api/v1/job-filter/job-table-columns`,
    filteredData
  );
  return data.payload;
}

export async function getJobTableFiltersAndColumns(): Promise<FiltersResponse> {
  const res = await axios.get<FiltersResponse>(`/api/v1/job-filter`);
  return res.data;
}
